<div class="container" [ngClass]="status().class">
  <div class="icon">
    <app-image [local]="true" [isIcon]="true" [name]="status().icon" [alt]="status().altName" />
  </div>
  <p>{{ status().label }}</p>
</div>